import Validator from './Classes/Validator';
import Fnc from './usefull';

export default Fnc;
export {Validator, Fnc};
